import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
    root: {
      textAlign: "center",
      padding: "20px"
    },
    buttonAccept: {
      textAlign: "center",
      padding: "25px"
    },
    warning: {
      color: theme.palette.warning.main,
      fontSize: 60, 
      maxWidth: 60,
      maxHeight: 60,
    },
    error: {
      color: theme.palette.error.main,
      fontSize: 60, 
      maxWidth: 60,
      maxHeight: 60,
    },
    info: {
      color: theme.palette.info.main,
      fontSize: 60, 
      maxWidth: 60,
      maxHeight: 60,
    }
}));

export default useStyles;